import { render, staticRenderFns } from "./current.vue?vue&type=template&id=3fd0c398&scoped=true"
import script from "./current.vue?vue&type=script&lang=js"
export * from "./current.vue?vue&type=script&lang=js"
import style0 from "./current.vue?vue&type=style&index=0&id=3fd0c398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd0c398",
  null
  
)

export default component.exports